import { render, staticRenderFns } from "./showInvoice.vue?vue&type=template&id=61379909"
import script from "./showInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./showInvoice.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports